export default __webpack_public_path__ + "static/media/kiosk.c0ea52f2.svg";